import { createFileRoute } from '@tanstack/react-router';

import { VerifyEmailPage, verifyEmailSearchSchema } from '@/pages/verify-email';

export const Route = createFileRoute('/verify-email')({
    validateSearch: verifyEmailSearchSchema,
    component: VerifyEmailRoute,
});

function VerifyEmailRoute() {
    const { token } = Route.useSearch();
    return <VerifyEmailPage token={token} />;
}
